import React from "react";

import FaceBookSVG from "./SVG/FaceBookSVG";
import TwitterSVG from "./SVG/TwitterSVG";
import LinkedInSVG from "./SVG/LinkedInSVG";
import InstagramSVG from "./SVG/InstagramSVG";
import WhatsappSVG from "./SVG/WhatsappSVG";

import "./Footer.css";

const Footer = () => {
  return (
    <footer className="footer container d-flex flex-column">
      <nav className="d-flex justify-between flex-wrap">
        <div className="pt-40">
          <h3>WHAT WE DO</h3>
          <ul>
            <li>
              <a href="/on/document-translations">Translation Services</a>
            </li>
            <li>
              <a href="/on/professional-transcription">
                Transcription Services
              </a>
            </li>
            <li>
              <a href="/on/interpretation-services">Interpretation Services</a>
            </li>
            <li>
              <a href="/on/notarized-translation">Notarizations</a>
            </li>
            <li>
              <a href="/on/apostile-transltion">Apostilles</a>
            </li>
          </ul>
        </div>
        <div className="pt-40">
          <h3>COMPANY</h3>
          <ul>
            <li>
              <a href="/company/#about-us">About Us</a>
            </li>
            <li>
              <a href="/join-us">Join Our Team</a>
            </li>
            <li>
              <a href="/contact-us">Support</a>
            </li>
            <li>
              <a href="/terms-and-condition">Terms of Service</a>
            </li>
            <li>
              <a href="/company/#process">Our Process</a>
            </li>
          </ul>
        </div>
        <div className="pt-40">
          <h3>INDUSTRIES</h3>
          <ul>
            <li>
              <a href="/on/life-sciences-translation">Life Science</a>
            </li>
            <li>
              <a href="/on/healthcare-translation-services">Healthcare</a>
            </li>
            <li>
              <a href="/on/marketing-translation">Marketing</a>
            </li>
            <li>
              <a href="/on/retail-and-ecommerce-translation">
                Retail and Ecommerce{" "}
              </a>
            </li>
            <li>
              <a href="/on/government-translation">Government</a>
            </li>
          </ul>
        </div>
        <div className="pt-40">
          <h3>ABOUT</h3>
          <ul>
            <li>
              <a href="/join-us/#faq">FAQ</a>
            </li>
            <li>
              <a href="/blog">Blog</a>
            </li>
            <li>
              <a href="/join-us">Careers</a>
            </li>
            <li>
              <a href="/join-us">Jobs</a>
            </li>
            <li>
              <a href="/company/#offices">Offices</a>
            </li>
          </ul>
        </div>
        <div className="pt-40">
          <h3>GET IN TOUCH</h3>
          <p style={{ maxWidth: "360px", marginBottom: "0" }}>
            Be the first to know about discounts, offers, news, giveaways and
            events
          </p>
          <ul className="d-flex align-center justify-between">
            <li>
              <a href="https://www.instagram.com/theofficialoneconverse/">
                <InstagramSVG />
              </a>
            </li>
            <li>
              <a href="https://twitter.com/Oneconverse1">
                <TwitterSVG />
              </a>
            </li>
            <li>
              <a href="/">
                <WhatsappSVG />
              </a>
            </li>
            <li>
              <a href="https://web.facebook.com/oneconverse/">
                <FaceBookSVG />
              </a>
            </li>
            <li>
              <a href="https://www.linkedin.com/company/81468693/admin/">
                <LinkedInSVG />
              </a>
            </li>
          </ul>
          <a href="mailto:support@oneconverse.com" className="footer__address">
            support@oneconverse.com
          </a>
        </div>
      </nav>
      <div className="footer__bottom mb-20 d-flex justify-between flex-wrap gap-10 font-heavy mt-40">
        <div>
          &copy;{new Date().getFullYear()} OneConverse. All Rights Reserved
        </div>
        <div className="d-flex gap-20 flex-wrap">
          <a href="/terms-and-condition">Privacy Policy</a>
          <a href="/pricing">Pricing</a>
          <a href="/terms-and-condition">Terms of use</a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
